import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';

const CartItem = ({ item }) => {
  const { addToCart, removeFromCart } = useContext(CartContext);

  return (
    <li className="cart-item">
      <button className="del-button" onClick={() => removeFromCart(item)}>-</button>
      <h2>{item.nom}</h2>
      <p className='quantity'>qte: {item.quantity}</p>
      <p className='price'>{item.prix} €</p>
      <button className="add-button" onClick={() => addToCart(item)}>+</button>
    </li>
  );
};

export default CartItem;
